import catalogServiceFactory from "../../../../common/services/catalog.factory";

class SearchStoreController {
  /* @ngInject */
  constructor($scope, $element, $rootScope, $filter, $timeout, StoreService) {
    const that = this;

    that.loading = {
      stores: false
    };

    that.filters = {
      search: {
        terms: [],
        text: ''
      }
    };

    const init = () => {
      that.initStoreList()
    };

    that.onSearch = () => {
      that.loading.stores = true;
      $timeout(filterShop, 100);
    };

    that.shopSelected = (shop) => {
      $rootScope.storeSelected(shop)
      that.onCancel()
    }

    that.initStoreList = () => {
      that.loading.stores = true;
      that.lista = _.map(StoreService.getSavedStoreList(), store => 
        { 
          return {
            option: store.name+", "+store.address,
            id: store.id
          }
        })  
        that.loading.stores = false;
    } 

    const filterShop = () => {
      console.log(that.filters.search.terms)
      console.log(that.filters.search.text)
      that.filteredList = $filter('filter')(that.lista, that.filters.search.text);
    }

    that.$onInit = init;

  }
}

export default SearchStoreController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/search/search.controller.js
 **/